import { ViewProductPayload, AddToCartPayload, AnalyticsContext } from "./types"

declare global {
  interface Window {
    addToCartKlaviyo: any
  }
}

declare global {
  interface Window {
    viewProductKlaviyo: any
  }
}

export const klaviyoEventPlugin = function klaviyoEventPlugin() {
  return {
    name: "klaviyo",
    track: (context: AnalyticsContext) => {
      const {
        payload: { event, properties },
      } = context

      if ("viewProduct" === event) {
        viewProduct(properties as ViewProductPayload)
        return
      }

      if ("addToCart" === event) {
        addToCart(properties as AddToCartPayload)
        return
      }
    },
  }
}

const viewProduct = (payload: ViewProductPayload) => {
  const klaviyoPayload = {
    Name: payload.title,
    ProductID: payload.id,
    Categories: payload.category,
    ImageURL: payload.image,
    URL: payload.link,
    Brand: payload.brand,
    Price: payload.price / 100,
    CompareAtPrice: payload.comparePrice,
  }
  window.viewProductKlaviyo(klaviyoPayload)
}

const addToCart = (payload: AddToCartPayload) => {
  const klaviyoPayload = {
    Name: payload.product.title,
    ProductID: payload.product.id,
    Categories: payload.product.category,
    ImageURL: payload.product.image,
    URL: payload.product.link,
    Brand: payload.product.brand,
    Price: payload.product.price / 100,
    CompareAtPrice: payload.product.comparePrice,
  }
  window.addToCartKlaviyo(klaviyoPayload)
}
